import { fetcher } from "../../../utils/fetcher";

async function downloadDocument(documentId?: string) {
  return await fetcher.get(`/pdf/download/${documentId}`, {
    responseType: "blob",
  });
}

export default downloadDocument;
